import { render } from "./InstrumentList.vue?vue&type=template&id=f37a44da&scoped=true"
import script from "./InstrumentList.vue?vue&type=script&lang=js"
export * from "./InstrumentList.vue?vue&type=script&lang=js"

import "./InstrumentList.vue?vue&type=style&index=0&id=f37a44da&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f37a44da"]])

export default __exports__